<template>
  <div class="page-shell page-shell--app-manage">
    <section class="page-shell__content">
      <div :class="{ 'page-shell__grid': showClassPanel }">
        <div
          v-if="showClassPanel"
          v-loading="classLoading"
          class="page-shell__panel page-shell__tree"
        >
          <div class="page-shell__panel-header">
            <div>
              <div class="page-shell__panel-title">应用分类</div>
              <div class="page-shell__panel-subtitle">
                通过分类树过滤模板列表，并维护分类层级。
              </div>
            </div>
            <el-button
              class="admin-list-tree-add"
              type="text"
              size="mini"
              @click="() => addChildClass()"
            >
              <i class="el-icon-circle-plus-outline" />
            </el-button>
          </div>
          <el-tree
            :data="classTree"
            show-checkbox
            node-key="appClassificationID"
            ref="classtree"
            default-expand-all
            :expand-on-click-node="false"
            @check-change="checkClassTree"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ data.appClassificationName }}</span>
              <el-dropdown trigger="click" @command="classHandleClick">
                <span class="el-dropdown-link">
                  <i
                    class="el-icon-arrow-down el-icon--right"
                    @click="classDropdownClick(data)"
                  ></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="checkNode(node)"
                    command="add"
                    >添加下级分类</el-dropdown-item
                  >
                  <el-dropdown-item command="modify">修改</el-dropdown-item>
                  <el-dropdown-item command="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
          </el-tree>
        </div>

        <div class="page-shell__panel">
          <div class="page-shell__panel-header">
            <div>
              <div class="page-shell__panel-title">应用列表</div>
              <div class="page-shell__panel-subtitle">
                结合分类、搜索、组织、状态和应用类型快速定位应用。
              </div>
            </div>
          </div>
          <public-table
            v-loading="Loading"
            :column="column"
            :tableData="tableData"
            :onAdd="() => (showCreateApp = true)"
            addPerm="Market.Application.Create"
            :enableSearch="true"
            :searchItems="searchItems"
            :PageInfo="listQuery"
            @handlePaginationChange="handleSearchList"
          >
            <template v-slot:name="{ row }">
              <el-button
                class="admin-list-primary-link"
                size="mini"
                type="text"
                @click="toAppDetailPage(row)"
                >{{ row.name }}</el-button
              >
            </template>
            <template v-slot:status="{ row }">
              <span
                v-if="row.status == 'upShelves'"
                class="admin-list-status admin-list-status--online"
              >
                已上架
              </span>
              <span
                v-if="row.status == 'downShelves'"
                class="admin-list-status admin-list-status--offline"
                >未上架</span
              >
            </template>
            <template v-slot:classificationName="{ row }">
              <el-tag
                v-if="row.classificationName"
                class="admin-list-chip"
                size="small"
                type="info"
              >
                {{ row.classificationName }}
              </el-tag>
              <span v-else style="color: #999">-</span>
            </template>
            <template v-slot:createTime="{ row }">
              {{ row.createTime ? timetrans(row.createTime) : '-' }}
            </template>
            <template v-slot:publishType="{ row }">
              {{ showPublishType(row.publishType) }}
            </template>
            <template v-slot:phone="{ row }">
              {{ row.phone ? row.phone : '-' }}
            </template>
            <template v-slot:real_name="{ row }">
              {{ row.real_name ? row.real_name : '-' }}
            </template>
            <template v-slot:versions="{ row }">
              <el-button
                class="admin-list-secondary-link"
                v-if="row.versions && row.versions.length > 0"
                size="mini"
                type="text"
                @click="toAppVersionPage(row)"
                >{{ row.versions[0].appVersion }}</el-button
              >
              <template v-else>暂无版本</template>
            </template>
            <template v-slot:operation="{ row }">
              <el-button
                class="admin-list-action"
                size="mini"
                type="text"
                v-permit="'Market.Application.Get'"
                @click="toAppDetailPage(row)"
                >管理</el-button
              >
              <el-button
                class="admin-list-action"
                size="mini"
                type="text"
                v-permit="'Market.Application.SetStatus'"
                @click="handleShelves(row)"
              >
                {{ row.status == 'upShelves' ? '下架' : '上架' }}
              </el-button>
              <el-button
                class="admin-list-action admin-list-action--danger"
                size="mini"
                type="text"
                v-permit="'Market.Application.Delete'"
                @click="handleDelete(row)"
                >删除</el-button
              >
            </template>
          </public-table>
        </div>
      </div>
    </section>

    <CreatApp
      v-if="showCreateApp"
      :marketID="marketID"
      :dialogVisible="showCreateApp"
      :onSuccess="createAppSuccess"
      :onClose="() => (showCreateApp = false)"
    ></CreatApp>
    <CreateOrEditAppClass
      v-if="showClassEdit"
      :marketID="marketID"
      :appClass="appClass"
      :parentAppClass="parentAppClassification"
      :dialogVisible="showClassEdit"
      :onSuccess="createAppClassSuccess"
      :onClose="closeClassEdit"
    ></CreateOrEditAppClass>
  </div>
</template>
<script>
import { getSelfAppList } from '@/api/user';
import PublicTable from '@/components/PublicTable/index.vue';
import { havePerm } from '@/utils/auth';
import { timetrans } from '@/utils/validate';
import { errorHandle } from '../../../utils/error';
import CreatApp from './components/createApp';
import CreateOrEditAppClass from './components/createOrEditAppClass';
const defaultListQuery = {
  page: 1,
  pageSize: 10,
  total: 1,
  query: '',
  orgID: '',
  status: '',
  publishType: '',
  classIDs: '',
  templateType: '',
  appCategory: ''
};

export default {
  name: 'AppManage',
  data() {
    const orgOptions = [];
    orgOptions.push({
      label: '全部',
      value: ''
    });
    this.$store.state.user.userOrgs.map((item) => {
      if (item) {
        orgOptions.push({
          label: item.name,
          value: item.orgID
        });
      }
    });
    const publishTypes = [
      {
        label: '全部',
        value: ''
      },
      {
        value: 'integral',
        label: '金额销售'
      },
      {
        value: 'public',
        label: '公开'
      },
      {
        value: 'private',
        label: '私有'
      },
      {
        value: 'show',
        label: '展览'
      }
    ];
    const appTypes = [
      {
        label: '全部',
        value: ''
      },
      {
        value: 'RAM',
        label: 'rainbond'
      },
      {
        value: 'helm',
        label: 'Helm chart'
      }
      // {
      //   value: 'software',
      //   label: '文件'
      // }
    ];
    const appCategories = [
      {
        label: '全部',
        value: ''
      },
      {
        label: '普通应用',
        value: 'normal'
      },
      {
        label: '平台插件应用',
        value: 'platformPlugin'
      }
    ];
    return {
      havePerm,
      showCreateApp: false,
      showClassEdit: false,
      curHandleClass: null,
      parentAppClassification: {},
      timetrans,
      searchItems: [
        {
          label: '名称',
          name: 'query',
          value: '',
          type: 'input'
        },
        {
          label: '组织机构',
          name: 'orgID',
          value: '',
          type: 'select',
          options: orgOptions
        },
        {
          label: '上架状态',
          name: 'status',
          value: '',
          type: 'select',
          options: [
            {
              label: '全部',
              value: ''
            },
            {
              value: 'upShelves',
              label: '销售中'
            },
            {
              value: 'downShelves',
              label: '未上架'
            }
          ]
        },
        {
          label: '应用类型',
          name: 'templateType',
          value: '',
          type: 'select',
          options: appTypes
        },
        {
          label: '应用归类',
          name: 'appCategory',
          value: '',
          type: 'select',
          options: appCategories
        }
        // {
        //   label: '发布类型',
        //   name: 'publishType',
        //   value: '',
        //   type: 'select',
        //   options: publishTypes
        // }
      ],
      column: [
        {
          prop: 'name',
          label: '名称',
          scopeStatus: true,
          fixed: 'left',
          minWidth: '150px'
        },
        {
          prop: 'status',
          label: 'Rainbond 展示',
          width: '150px',
          scopeStatus: true
        },
        {
          prop: 'classificationName',
          label: '分类',
          scopeStatus: true,
          minWidth: '140px'
        },
        {
          prop: 'real_name',
          label: '作者',
          scopeStatus: true,
          width: '100px'
        },
        {
          prop: 'phone',
          label: '联系方式',
          scopeStatus: true,
          width: '120px'
        },
        {
          prop: 'versions',
          label: '版本',
          scopeStatus: true,
          width: '100px'
        },
        {
          prop: 'createTime',
          label: '更新时间',
          scopeStatus: true,
          width: '150px'
        },
        {
          prop: 'operation',
          label: '操作',
          scopeStatus: true,
          width: '150px',
          fixed: 'right'
        }
      ],
      publishTypes: publishTypes,
      tableData: [],
      listQuery: Object.assign({}, defaultListQuery),
      list: null,
      total: null,
      Loading: false,
      classTree: [],
      classLoading: true,
      appClass: {}
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    showClassPanel() {
      return havePerm('Market.Application.AppClassification.List');
    },
    // 当前用户信息
    currentUserInfo() {
      return this.$store.state.user.userInfo;
    }
  },
  components: {
    PublicTable,
    CreatApp,
    CreateOrEditAppClass
  },
  created() {
    this.handleCreated();
    if (this.showClassPanel) {
      this.fetchStoreAppClassList();
    }
  },
  methods: {
    handleCreated() {
      // 企业管理员查看所有的应用列表
      if (
        havePerm('Market.Application.List') &&
        havePerm('Market.Application.SelfList')
      ) {
        this.fetchStoreAppList();
      } else {
        const params = {
          marketID: this.marketID,
          userID: this.currentUserInfo.userID,
          page: 1,
          pageSize: 10
        };
        // 否则的话,查看自己所管理的应用
        getSelfAppList(params).then((res) => {
          if (res && res.apps && res.apps.length > 0) {
            this.tableData = res.apps;
          } else {
            this.tableData = [];
          }
        });
      }
    },
    // 获取当前用户自己的应用
    handleLoadSelfApp() {},
    // 分类操作点击
    classHandleClick(cmd) {
      const data = this.curHandleClass;
      if (cmd === 'add') {
        this.addChildClass(data);
      } else if (cmd === 'modify') {
        this.editAppClass(data);
      } else {
        this.removeAppClass(data);
      }
    },
    // 分类操作
    classDropdownClick(c) {
      this.curHandleClass = c;
    },
    checkNode(node) {
      return node.level <= 1;
    },
    showPublishType(t) {
      let show = t;
      this.publishTypes.map((item) => {
        if (item.value == t) {
          show = item.label;
        }
      });
      return show;
    },
    handleSearchList(parameter) {
      if (parameter) {
        this.listQuery.page = 1;
        this.listQuery = Object.assign(this.listQuery, parameter);
      } else {
        this.listQuery.page = 1;
      }
      this.handleCreated();
    },
    handleDelete(row) {
      this.$confirm('是否要删除该应用?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch('DeleteStoreApp', {
            marketID: this.marketID,
            appID: row.appKeyID
          })
          .then((res) => {
            if (res) {
              this.handleCreated();
              this.$message({
                type: 'success',
                message: '应用删除成功'
              });
            }
          })
          .catch((re) => {
            this.Loading = false;
            errorHandle(re);
          });
      });
    },
    handleShelves(row) {
      const message =
        row.status == 'upShelves' ? '是否要下架该应用?' : '是否要上架该应用?';
      const newStatus = row.status == 'upShelves' ? 'downShelves' : 'upShelves';
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store
          .dispatch('ChangeStoreAppStatus', {
            marketID: this.marketID,
            appID: row.appKeyID,
            status: newStatus
          })
          .then((res) => {
            if (res) {
              // 判断权限
              this.handleCreated();
              this.$message({
                type: 'success',
                message:
                  newStatus == 'upShelves' ? '应用上架成功' : '应用下架成功'
              });
            }
          })
          .catch((re) => {
            errorHandle(re);
          });
      });
    },
    toAppDetailPage(row) {
      this.$router.push({
        name: 'StoreTemplateManageDetails',
        params: { appID: row.appKeyID, tabMode: 'detail', appType: row.type }
      });
    },
    toAppPackagesPage(row) {
      this.$router.push({
        name: 'StoreAppManagePackage',
        params: { appID: row.appKeyID }
      });
    },
    checkClassTree(data) {
      const nodes = this.$refs.classtree.getCheckedNodes();
      const classIDs = [];
      nodes.map((item) => {
        classIDs.push(item.appClassificationID);
      });
      if (classIDs.join(',') != this.listQuery.classIDs) {
        this.listQuery.classIDs = classIDs.join(',');
        this.handleCreated();
      }
    },
    fetchStoreAppList() {
      this.Loading = true;
      this.$store
        .dispatch(
          'GetStoreAppManageList',
          Object.assign({ marketID: this.marketID }, this.listQuery)
        )
        .then((res) => {
          if (res) {
            this.tableData = res.apps || [];
            this.listQuery.total = res.total;
          }
          this.Loading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.Loading = false;
        });
    },
    fetchStoreAppClassList() {
      this.classLoading = true;
      this.$store
        .dispatch('GetStoreAppClassificationList', { marketID: this.marketID })
        .then((res) => {
          this.classTree = res && res.tree ? res.tree : [];
          this.classLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.classLoading = false;
        });
    },
    addChildClass(node) {
      if (node) {
        this.parentAppClassification = node;
      }
      this.showClassEdit = true;
    },
    editAppClass(node) {
      this.appClass = node;
      this.showClassEdit = true;
    },
    createAppClassSuccess() {
      this.showClassEdit = false;
      this.fetchStoreAppClassList();
      this.handleCreated();
    },
    closeClassEdit() {
      this.parentAppClassification = {};
      this.appClass = {};
      this.showClassEdit = false;
    },
    createAppSuccess() {
      this.showCreateApp = false;
      this.handleCreated();
    },
    removeAppClass(node) {
      this.$confirm('删除后该分类下的应用将移除此分类，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store
            .dispatch('DeleteStoreAppClassification', {
              marketID: this.marketID,
              appClassificationID: node.appClassificationID
            })
            .then((res) => {
              this.fetchStoreAppClassList();
              this.handleCreated();
            })
            .catch((res) => {
              if (res.code === 10022) {
                this.$message({
                  message: '存在下级分类，不能删除',
                  type: 'warning'
                });
                return;
              }
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            });
        })
        .catch(() => {});
    },
    toAppVersionPage(row) {
      this.$router.push({
        name: 'StoreTemplateManageDetails',
        params: {
          appID: row.appKeyID,
          tabMode: 'versions'
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import 'src/styles/page-shell.scss';

.el-tree-node > .el-tree-node__children {
  overflow: inherit;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  span {
    line-height: 1.5;
  }

  .el-dropdown-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    color: #7f93a7;
    padding: 4px;
    border-radius: 10px;
    transition: color 0.2s ease, background-color 0.2s ease;

    &:hover {
      color: #3f6f9e;
      background: rgba(232, 240, 248, 0.9);
    }
  }
}

.admin-list-tree-add {
  width: 34px;
  height: 34px;
  padding: 0;
  border-radius: 12px;
  background: linear-gradient(180deg, #f2f7fb 0%, #e9f0f7 100%);
  color: #416f9a;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.92);

  &:hover,
  &:focus {
    color: #335d85;
    background: linear-gradient(180deg, #e8f0f8 0%, #dee9f3 100%);
  }
}

.admin-list-chip {
  border-color: rgba(178, 197, 214, 0.8) !important;
  background: linear-gradient(180deg, #f8fbfd 0%, #edf3f8 100%) !important;
  color: #586f85 !important;
}

.admin-list-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 76px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.admin-list-status--online {
  background: rgba(33, 162, 107, 0.12);
  color: #1e8f61;
}

.admin-list-status--offline {
  background: rgba(217, 118, 42, 0.12);
  color: #b96d2d;
}

.admin-list-primary-link,
.admin-list-secondary-link,
.admin-list-action {
  padding: 0 !important;
  font-weight: 600;
}

.admin-list-primary-link {
  color: #264d72 !important;
}

.admin-list-secondary-link,
.admin-list-action {
  color: #3f6f9e !important;
}

.admin-list-action--danger {
  color: #c2603c !important;
}
</style>
<!-- :column="havePerm('Market.Application.List') && havePerm('Market.Application.SelfList') ? adminColumn : column" -->



// WEBPACK FOOTER //
// src/views/storeManage/appManage/index.vue